<template>
  <Teleport to="body">
    <div
      class="tw-absolute tw-right-4 tw-top-2 tw-z-[60] tw-flex tw-flex-col-reverse tw-gap-2"
    >
      <cl-toast
        v-for="toast in toasts"
        :key="toast.id"
        :id="toast.id"
        :title="toast.title"
        :message="toast.message"
        :variant="toast.variant"
        @on-close="closeToast"
      />
    </div>
  </Teleport>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Toasts",
  methods: {
    ...mapActions("toast", ["closeToast"]),
  },
  computed: mapGetters("toast", ["toasts"]),
};
</script>
